export class DrugLookup {
    brand: string;
    strength: string;
    quantity: number;
}


// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/shared/drug-lookup.ts